<template>
  <v-row class="text-center mr-4 mt-0">
    <v-col>
      <v-btn
        rounded
        depressed
        class="px-8"
        @click="select(true)"
        :class="{ 'primary white--text': (selected === true) }"
      >
        {{ $t('YES') }}
      </v-btn>
    </v-col>
    <v-col>
      <v-btn
        rounded
        depressed
        class="px-8"
        @click="select(false)"
        :class="{'primary white--text': (selected === false) }"
      >
        {{ $t('NO') }}
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'FormBool',
  // props: {
  //   value: {
  //     type: Boolean,
  //     default: false,
  //   },
  // },
  data: () => ({
    selected: null,
  }),
  methods: {
    select(val) {
      this.selected = val;
      this.$emit('select', val);
    },
  },
};
</script>
